import { StatisticDonutDataType } from './types';

export function getDonutName(dataType: StatisticDonutDataType) {
    return dataType;
}
